/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
String.implement(
{
	explode: function(delimiter)
	{
		var pieces = this.split(delimiter);
		return pieces;
	},

	add_commas: function(prefix) {
		if(isNaN(this) || this <= 0) {
			return '';
		} else {
			prefix = (prefix) ? prefix : '';
			var num = this + '';
			var x = num.split('.');
			var x1 = x[0];
			var x2 = x.length > 1 ? '.' + x[1] : '';
			var rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + ',' + '$2');
			}
			return prefix + x1 + x2;
		}
	},

	convert_to_number: function() {
		var number = this.trim().replace(/[^0-9]/g, "");
		number = (number <= 0 || isNaN(number)) ? "" : number;
		return number;
	},

	convert_any_to_float: function() {
		var match = this.toString().match(/[0-9,.$]*/);
		if (match!==null) {
			return parseFloat( match[0].replace(/[,$]/g, '')) || 0;
		}
		return 0;
	},

	convert_any_to_int: function() {
		var match = this.toString().match(/[0-9,.$]*/);
		if (match!==null) {
			return Math.round(parseFloat( match[0].replace(/[,$]/g, '')));
		}
		return 0;
	}
});
